module.exports = __webpack_public_path__ + "static/media/2023_45.43e3e597.jpg";